import { useQuery } from '@tanstack/react-query';
import { clubConditionsApi } from '../services/apiService';
import { useTimeFrame } from '../contexts/TimeFrameContext';
import { TimePeriod } from '../types/api';
import { ClubConditionsData, ClubConditionsResponse } from '../types/clubConditions';
import { logger } from '../utils/logger';

// Query keys for cache management
export const CLUB_CONDITIONS_QUERY_KEYS = {
  CLUB_CONDITIONS_DATA: 'clubConditionsData',
};

/**
 * Hook to fetch club conditions data
 */
export function useClubConditionsData(branchId: number | undefined, customTimeRange?: TimePeriod) {
  // Use the timeFrame from context
  const { apiTimeFrame } = useTimeFrame();
  
  // Use custom time range if provided, otherwise use the one from context
  const timeRange = customTimeRange || apiTimeFrame;
  
  return useQuery<ClubConditionsResponse>({
    queryKey: [CLUB_CONDITIONS_QUERY_KEYS.CLUB_CONDITIONS_DATA, branchId, timeRange],
    queryFn: async () => {
      if (!branchId) throw new Error('Branch ID is required');
      
      try {
        const response = await clubConditionsApi.getClubConditionsData(branchId, timeRange);
        return response;
      } catch (error) {
        logger.error('Failed to fetch club conditions data', 'ClubConditionsQueries', error);
        // Return empty data structure to prevent UI errors
        throw error;
      }
    },
    enabled: !!branchId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });
}